import { render, staticRenderFns } from "./OrderSummaryCard.vue?vue&type=template&id=29ed9c13&"
import script from "./OrderSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions})
